import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type Theme = 'light' | 'dark' | 'system';

interface UiState {
  sidebarCollapsed: boolean;
  theme: Theme;
  toggleSidebar: () => void;
  setTheme: (t: Theme) => void;
}

/**
 * UI-level client state (sidebar / theme). Server data goes through TanStack Query,
 * auth session goes through auth-store. Keep each store single-purpose.
 */
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      theme: 'system',
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'ads-admin-ui',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
